// ClientRoutes
import { ClientRoutes } from '../Routes';

/* eslint-disable no-undef */
const currencySymbols = {
    "USD" : "$", 
    "EUR" : "€", 
    "GBP" : "£", 
    "JPY" : "¥", 
    "CAD" : "$",
    "ETH" : "Ξ",
    "BTC" : "฿",
    "XMR" : "ɱ",
    "USDT" : "₮",
    "KRW" : "₩"
};

const fiatCurrencies = ['USD', 'EUR', 'GBP', 'JPY', 'CAD'];

//const CURRENCIES = JSON.parse(localStorage.getItem('currencies'));

// If currencies are cached, return
// Otherwise, fetch, store and return
function getCurrencies() {

    //console.log('CurrencyStore.getCurrencies()');

    return new Promise( (resolve, reject) => {

        var currencies = JSON.parse(localStorage.getItem('currencies'));
        
        // No currencies, fetch them, store and return
        if(currencies === null || typeof currencies !== "object") {
        
            ClientRoutes.getCurrencyList()
                .then( (newCurrencies) => {

                    localStorage.setItem('currencies', JSON.stringify(newCurrencies));
                    resolve(newCurrencies);
    
                })
                .catch( (error) => {
                    reject('Error Fetching Currencies');
                });
        }
        else {
            resolve(currencies);
        }

    });

}


// Given a ticker, return the coins actual name
function getCoinName(ticker) {

    var currencies = JSON.parse(localStorage.getItem('currencies'));

    if(currencies === null) {
        
        return "";
    }
    else {

        try {
            var name = currencies[ticker].name;
            return name;
        } catch(error) {
            return ticker;
        }

    }


}


// Return the list of exchanges and their underlying quote currencies
function getExchanges() {

    return new Promise( (resolve, reject) => {
        
        var exchanges = JSON.parse(localStorage.getItem('settings_all_exchanges'));
        
        // No exchanges, fetch them, store and return
        if(exchanges == null) {
        
            ClientRoutes.getExchangeList()
                .then( (newExchanges) => {
    
                    localStorage.setItem('settings_all_exchanges', JSON.stringify(newExchanges));
                    resolve(newExchanges);

                })
                .catch( (error) => {
                    reject('Error Fetching exchanges');
                });
        }
        else {
            resolve(exchanges);
        }

    });

}


// Returns the currency symbols
function getCurrencySymbols() {

    return currencySymbols;

}


// Given a currency, return its proper symbol
// If currency not in list, return ''
function getCurrencySymbol(currency) {

    if(currencySymbols.hasOwnProperty(currency))
        return currencySymbols[currency];
    else
        return '';

}


// Returns the Numeral format for currency
function getCurrencyFormat() {

    return '(0,0.00)';

}

// Returns the Numeral format for crypto
function getCryptoFormat() {

    return '(0.00000000)';
}


// Returns the proper numeral format for a given currency
function getFormat(currency) {

    if(fiatCurrencies.includes(currency))
        return getCurrencyFormat();
    else
        return getCryptoFormat();

}

// Given a number of decimals, return the format
function getDecimalsFormat(decimals) {

    var format = '(0,0.' + '0'.repeat(decimals) + ')';

    return format;

}


const CurrencyStore = { getCurrencies, getExchanges, getCoinName, getCurrencySymbols, getCurrencySymbol, getCurrencyFormat, getCryptoFormat, getFormat, getDecimalsFormat };
export default CurrencyStore;






// WEBPACK FOOTER //
// ./src/Stores/CurrencyStore.js